// GenLoyal white-label: sustituye la marca Chatwoot → GenLoyal en runtime, como
// hook `postTranslation` de vue-i18n, en vez de editar los archivos de locale
// (que serían puntos de conflicto de merge en cada rebase de upstream).
//
// Reglas ORDENADAS: los taglines "Desarrollado por / Powered by" usan la marca
// corta "GenLoyal"; el resto usa el nombre de producto "GenLoyal Chat". Corren
// sobre el string YA interpolado (postTranslation es post-interpolación en
// vue-i18n 9), así que los placeholders tipo {latestChatwootVersion} nunca llegan
// acá con "Chatwoot" adentro. Case-sensitive a propósito: los identificadores de
// la API pública en minúscula (chatwootSDK, chatwootSettings, window.$chatwoot)
// nunca matchean y quedan intactos en los snippets de código que el usuario copia.
// Los taglines cubren los locales que hoy usamos (ES/EN). El tagline de otro
// idioma ("Développé par Chatwoot", etc.) cae al catch-all → "GenLoyal Chat"
// en vez de la marca corta: la marca no filtra igual, sólo cambia el matiz.
const RULES = [
  [/Chatwoot AI/g, 'GenLoyal AI'], // 1. producto AI
  [/Desarrollado por Chatwoot/g, 'Desarrollado por GenLoyal'], // 2. tagline ES
  [/Powered by Chatwoot/g, 'Powered by GenLoyal'], // 3. tagline EN
  [/Chatwoot/g, 'GenLoyal Chat'], // 4. resto → nombre de producto
];

// vue-i18n postTranslation hook. Fast-path: la gran mayoría de strings no
// contienen la marca y salen sin correr ninguna regex.
export function postTranslation(str) {
  if (typeof str !== 'string' || !str.includes('Chatwoot')) return str;
  return RULES.reduce((s, [re, to]) => s.replace(re, to), str);
}
